import React from 'react';
import {
	FaUserAlt,
	FaPhoneAlt,
	FaBirthdayCake,
	FaLock,
	FaLocationArrow,
	FaEnvelope,
} from 'react-icons/fa';

const ProfileCard = ({ userData, handleRandomUserClick }) => {
	const { image, name, email, dob, location, phone, password } = userData;

	const [randomUserClicked, setrandomUserClicked] = React.useState(false);

	const defaultFlag = {
		name: 'active',
		email: '',
		dob: '',
		location: '',
		phone: '',
		password: '',
	};

	const [flag, setFlag] = React.useState(defaultFlag);
	const [title, setTitle] = React.useState('My Name Is');
	const [value, setValue] = React.useState(name);

	const handleValue = (e) => {
		if (e.target.dataset.label === 'name') {
			setTitle('My Name is');
			setValue(name);
			setFlag(defaultFlag);
		} else if (e.target.dataset.label === 'email') {
			setTitle('My Email is');
			setValue(email);
			setFlag({
				name: '',
				email: 'active',
				dob: '',
				location: '',
				phone: '',
				password: '',
			});
		} else if (e.target.dataset.label === 'dob') {
			setTitle('My Birthday is');
			setValue(new Date(dob).toLocaleDateString());
			setFlag({
				name: '',
				email: '',
				dob: 'active',
				location: '',
				phone: '',
				password: '',
			});
		} else if (e.target.dataset.label === 'location') {
			setTitle('I live in');
			setValue(location);
			setFlag({
				name: '',
				email: '',
				dob: '',
				location: 'active',
				phone: '',
				password: '',
			});
		} else if (e.target.dataset.label === 'phone') {
			setTitle('My phone number is');
			setValue(phone);
			setFlag({
				name: '',
				email: '',
				dob: '',
				location: '',
				phone: 'active',
				password: '',
			});
		} else {
			setTitle('My password');
			setValue(password);
			setFlag({
				name: '',
				email: '',
				dob: '',
				location: '',
				phone: '',
				password: 'active',
			});
		}

		if (e.target.dataset.label === 'random') {
			handleRandomUserClick();
			setrandomUserClicked(!randomUserClicked);
		}
	};

	React.useEffect(() => {
		setTitle('My Name is');
		setValue(name);
		setFlag(defaultFlag);
	}, [randomUserClicked]);

	return (
		<article className='profile-card'>
			<img src={image} alt={name} />

			<div className='user-details'>
				<p className='user-title'>{title}</p>
				<h3 className='user-value'>{value || name}</h3>
			</div>

			<ul className='card-list'>
				<li className={flag.name} onMouseEnter={handleValue} data-label='name'>
					<FaUserAlt className='icon' />
				</li>
				<li
					data-label='email'
					onMouseEnter={handleValue}
					className={flag.email}
				>
					<FaEnvelope className='icon' />
				</li>
				<li data-label='dob' onMouseEnter={handleValue} className={flag.dob}>
					<FaBirthdayCake className='icon' />
				</li>
				<li
					data-label='location'
					onMouseEnter={handleValue}
					className={flag.location}
				>
					<FaLocationArrow className='icon' />
				</li>
				<li
					data-label='phone'
					onMouseEnter={handleValue}
					className={flag.phone}
				>
					<FaPhoneAlt className='icon' />
				</li>
				<li
					data-label='password'
					onMouseEnter={handleValue}
					className={flag.password}
				>
					<FaLock className='icon' />
				</li>
			</ul>
			{/* Also handling this click within handleValue function */}
			<button className='btn' onClick={handleValue} data-label='random'>
				Random User
			</button>
		</article>
	);
};

export default ProfileCard;
